// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:.75rem;font-weight:700;color:#004396}h1{font-size:2.5rem;line-height:.9}h2{font-size:2.1875rem;line-height:.95}h3{font-size:1.875rem;line-height:1}h4{font-size:1.5rem;line-height:1.05}h5{font-size:1.125rem;line-height:1.1}h6{font-size:1rem;line-height:1.15}p{font-size:2rem;margin-top:0}", ""]);
// Exports
module.exports = exports;
